import { Col, Form, Icon, Input, Row } from 'antd';
import { decode } from 'html-entities';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function TokenScreen({
	form,
	language,
	formNumber,
	showDeviceId,
	showNamespace,
	onFieldChange,
}) {
	const { getFieldDecorator } = form;
	return (
		<>
			{formNumber.api !== '' ? (
				<Row>
					<Col span={14} style={{ padding: 10 }}>
						<div
							dangerouslySetInnerHTML={{
								__html: decode(language[formNumber.api + '_desc']),
							}}
							style={{ fontSize: 12 }}
						/>
						<img
							src={require(`assets/steps/${formNumber.api}.png`)}
							alt="Token"
							className="w-100 h-100"
						/>
					</Col>
					<Col span={10} style={{ padding: 10 }}>
						<div style={{ fontSize: 22 }}>
							<FormattedMessage id="with_base" />
						</div>
						<br />
						<br />
						<div style={{ fontSize: 22 }}>
							<FormattedMessage id="type_token" />
						</div>
						<FormattedMessage id="numbers_form_token">
							{(msg) => (
								<Input
									prefix={<Icon type="code" style={{ color: 'rgba(0,0,0,.25)' }} />}
									placeholder={msg}
									onChange={(e) => onFieldChange('token', e.target.value)}
								/>
							)}
						</FormattedMessage>
						<br />
						{showDeviceId ? (
							<>
								<br />
								<div style={{ fontSize: 22 }}>
									<FormattedMessage id="type_device_id" />
								</div>
								<Form.Item>
									{getFieldDecorator('account', {
										rules: [
											{
												required: false,
												message: <FormattedMessage id="form_msg_account" />,
											},
										],
									})(
										<FormattedMessage id="form_account">
											{(msg) => (
												<Input
													prefix={
														<Icon
															type="tag"
															style={{
																color: 'rgba(0,0,0,.25)',
															}}
														/>
													}
													placeholder={msg}
													onChange={(e) => onFieldChange('device_id', e.target.value)}
												/>
											)}
										</FormattedMessage>,
									)}
								</Form.Item>
							</>
						) : null}
						{showNamespace ? (
							<>
								<div style={{ fontSize: 22 }}>
									<FormattedMessage id="type_namespace" />
								</div>
								<Form.Item>
									{getFieldDecorator('namespace', {
										rules: [
											{
												required: false,
												message: <FormattedMessage id="form_msg_namespace" />,
											},
										],
									})(
										<FormattedMessage id="form_namespace">
											{(msg) => (
												<Input
													prefix={
														<Icon
															type="tag"
															style={{
																color: 'rgba(0,0,0,.25)',
															}}
														/>
													}
													placeholder={msg}
													onChange={(e) => onFieldChange('namespace', e.target.value)}
												/>
											)}
										</FormattedMessage>,
									)}
								</Form.Item>
							</>
						) : null}
					</Col>
				</Row>
			) : null}
		</>
	);
}
